import _ from "lodash";
import { Menu } from "./menu";

export class MenuIndex {
    title;
    subList;
    page;
    constructor(title: string, page: number, subList?: Array<Menu>){
        this.title = title;
        this.page = page;
        this.subList = subList;
    }
}



